<template>
	<div>
		<router-view
		class="view"
		keep-alive
		transition
		transition-mode="out-in">
		</router-view>
	</div>
</template>
<script>
export default {
	components : {}
}
</script>



// WEBPACK FOOTER //
// App.vue?e52b4e58